<div class="remote-console">
	<!-- =====================================================
	     ENCABEZADO GENERAL
	     ===================================================== -->
	<header class="remote-console__header">
		<div class="device-heading">
			<div class="device-heading__icon">
				<i class="pi pi-desktop"></i>
			</div>

			<div class="device-heading__content">
				<span class="device-heading__eyebrow">
					Control remoto
				</span>

				<h4>
					{{ headerText || "Dispositivo NetRIDE" }}
				</h4>

				<span class="device-heading__channel">
					Canal: {{ data?.channel || "No definido" }}
				</span>
			</div>
		</div>

		<div class="connection-status">
			<div
				class="status-chip"
				[class.status-chip--success]="is_user_connect"
				[class.status-chip--inactive]="!is_user_connect"
			>
				<span class="status-chip__indicator"></span>

				<div>
					<small>Servidor</small>
					<strong>
						{{
							is_user_connect
								? "Conectado"
								: "Desconectado"
						}}
					</strong>
				</div>
			</div>

			<div
				class="status-chip"
				[class.status-chip--success]="isConnected"
				[class.status-chip--inactive]="!isConnected"
			>
				<span class="status-chip__indicator"></span>

				<div>
					<small>Dispositivo</small>
					<strong>
						{{
							isConnected
								? "Disponible"
								: "Sin respuesta"
						}}
					</strong>
				</div>
			</div>

			<button
				type="button"
				class="btn btn-outline-primary btn-sm reconnect-button"
				(click)="reconect()"
				[disabled]="is_user_connect"
			>
				<i class="pi pi-refresh"></i>
				Reconectar
			</button>
		</div>
	</header>

	<!-- =====================================================
	     CONTENIDO PRINCIPAL
	     ===================================================== -->
	<div class="remote-console__body">
		<!-- Terminal -->
		<section class="terminal-panel">
			<header class="terminal-panel__header">
				<div class="terminal-panel__title">
					<span class="terminal-dots">
						<i></i>
						<i></i>
						<i></i>
					</span>

					<div>
						<strong>Terminal del dispositivo</strong>
						<small>
							Actividad y respuestas en tiempo real
						</small>
					</div>
				</div>

				<div
					class="terminal-status"
					[class.terminal-status--online]="isConnected"
				>
					<i
						class="pi"
						[class.pi-check-circle]="isConnected"
						[class.pi-exclamation-circle]="!isConnected"
					></i>

					{{
						isConnected
							? "Dispositivo activo"
							: "Dispositivo inactivo"
					}}
				</div>
			</header>

			<div
				id="terminal"
				class="terminal-panel__content font-monospace"
				role="log"
				aria-live="polite"
				aria-label="Mensajes del dispositivo"
			>
				<div class="terminal-empty">
					<i class="pi pi-code"></i>

					<strong>Terminal lista</strong>

					<span>
						Las respuestas del dispositivo aparecerán aquí.
					</span>
				</div>
			</div>

			<footer class="terminal-panel__prompt">
				<span
					class="prompt-indicator"
					[class.prompt-indicator--online]="is_user_connect"
				></span>

				<span class="prompt-user">
					{{ username || "usuario" }}@
				</span>

				<span class="prompt-path">
					~/Netride
				</span>

				<span class="prompt-symbol">$</span>

				<span class="prompt-message">
					Esperando comandos...
				</span>
			</footer>
		</section>

		<!-- =================================================
		     PANEL DE CONFIGURACIÓN
		     ================================================= -->
		<aside
			class="settings-panel"
			aria-label="Configuración remota"
		>
			<div class="settings-panel__heading">
				<div>
					<h5>Configuración</h5>
					<span>
						Seleccione una sección para modificarla
					</span>
				</div>

				<i class="pi pi-sliders-h"></i>
			</div>

			<!-- =============================================
			     BANNER INFORMATIVO
			     ============================================= -->
			<details
				class="setting-card setting-card--featured"
				open
			>
				<summary class="setting-card__summary">
					<div class="setting-card__identity">
						<span class="setting-card__icon">
							<i class="pi pi-megaphone"></i>
						</span>

						<div>
							<strong>Banner informativo</strong>
							<small>
								Mostrar un Lower Third en pantalla
							</small>
						</div>
					</div>

					<i
						class="pi pi-chevron-down setting-card__chevron"
					></i>
				</summary>

				<div class="setting-card__body">
					<div class="form-field">
						<div class="form-field__label">
							<label for="lowerThirdTitle">
								Título
								<span class="required-mark">*</span>
							</label>

							<small>
								{{ lowerThirdTitle?.length || 0 }}/60
							</small>
						</div>

						<input
							id="lowerThirdTitle"
							type="text"
							class="form-control"
							[(ngModel)]="lowerThirdTitle"
							name="lowerThirdTitle"
							maxlength="60"
							placeholder="Ej. ÚLTIMA HORA"
						/>
					</div>

					<div class="form-field">
						<div class="form-field__label">
							<label for="lowerThirdSubtitle">
								Subtítulo
							</label>

							<small>
								{{ lowerThirdSubtitle?.length || 0 }}/80
							</small>
						</div>

						<input
							id="lowerThirdSubtitle"
							type="text"
							class="form-control"
							[(ngModel)]="lowerThirdSubtitle"
							name="lowerThirdSubtitle"
							maxlength="80"
							placeholder="Ej. CENTRO"
						/>
					</div>

					<div class="form-field">
						<div class="form-field__label">
							<label for="lowerThirdText">
								Mensaje
								<span class="required-mark">*</span>
							</label>

							<small>
								{{ lowerThirdText?.length || 0 }}/240
							</small>
						</div>

						<textarea
							id="lowerThirdText"
							class="form-control lower-third-textarea"
							[(ngModel)]="lowerThirdText"
							name="lowerThirdText"
							rows="3"
							maxlength="240"
							placeholder="Escriba el mensaje que aparecerá en pantalla"
						></textarea>
					</div>

					<div class="form-grid">
						<div class="form-field">
							<label for="lowerThirdPanel">
								Panel
							</label>

							<select
								id="lowerThirdPanel"
								class="form-select"
								[(ngModel)]="lowerThirdPanelId"
								name="lowerThirdPanelId"
							>
								<option
									*ngFor="
										let panel of lowerThirdPanelOptions
									"
									[value]="panel.value"
								>
									{{ panel.label }}
								</option>
							</select>
						</div>

						<div class="form-field">
							<label for="lowerThirdDuration">
								Duración
							</label>

							<div class="input-group">
								<input
									id="lowerThirdDuration"
									type="number"
									class="form-control"
									[(ngModel)]="
										lowerThirdDurationSeconds
									"
									name="lowerThirdDurationSeconds"
									min="1"
									max="300"
									step="1"
								/>

								<span class="input-group-text">
									seg
								</span>
							</div>
						</div>
					</div>

					<!-- Vista previa -->
					<div class="lower-third-preview">
						<div class="lower-third-preview__label">
							Vista previa
						</div>

						<div class="lower-third-preview__screen">
							<div class="lower-third-preview__accent"></div>

							<div class="lower-third-preview__content">
								<strong>
									{{
										lowerThirdTitle ||
											"TÍTULO DEL BANNER"
									}}
								</strong>

								<span>
									{{
										lowerThirdSubtitle ||
											"SUBTÍTULO"
									}}
								</span>

								<p>
									{{
										lowerThirdText ||
											"El mensaje del banner aparecerá aquí."
									}}
								</p>
							</div>
						</div>
					</div>

					<button
						type="button"
						class="btn btn-primary w-100 setting-primary-action"
						(click)="sendLowerThird()"
						[disabled]="!canSendLowerThird"
					>
						<i class="pi pi-send"></i>
						Enviar banner
					</button>

					<div
						*ngIf="!isConnected"
						class="setting-feedback setting-feedback--error"
					>
						<i class="pi pi-exclamation-circle"></i>

						El dispositivo debe estar conectado para enviar
						el banner.
					</div>
				</div>
			</details>

			<!-- =============================================
			     AUDIO
			     ============================================= -->
			<details class="setting-card">
				<summary class="setting-card__summary">
					<div class="setting-card__identity">
						<span class="setting-card__icon">
							<i class="pi pi-volume-up"></i>
						</span>

						<div>
							<strong>Audio</strong>
							<small>
								Volumen de reproducción
							</small>
						</div>
					</div>

					<div class="setting-card__summary-end">
						<span class="setting-value">
							{{ audioVolume ?? 0 }}%
						</span>

						<i
							class="pi pi-chevron-down setting-card__chevron"
						></i>
					</div>
				</summary>

				<div class="setting-card__body">
					<div class="volume-control">
						<div class="volume-control__icons">
							<i class="pi pi-volume-off"></i>
							<i class="pi pi-volume-up"></i>
						</div>

						<input
							id="volume"
							type="range"
							class="form-range"
							[(ngModel)]="audioVolume"
							name="audioVolume"
							min="0"
							max="100"
							step="1"
							[attr.aria-valuenow]="audioVolume"
							aria-label="Volumen"
						/>

						<div class="volume-control__value">
							{{ audioVolume ?? 0 }}%
						</div>
					</div>

					<div class="setting-actions">
						<button
							type="button"
							class="btn btn-primary"
							(click)="applyVolume(audioVolume)"
							[disabled]="
								audioVolume === null ||
								audioVolume === undefined ||
								audioVolume < 0 ||
								audioVolume > 100
							"
						>
							<i class="pi pi-check"></i>
							Aplicar
						</button>

						<button
							type="button"
							class="btn btn-outline-secondary"
							(click)="
								sendcommand(
									'GET_VOLUME',
									'Solicitando volumen'
								)
							"
						>
							<i class="pi pi-refresh"></i>
							Consultar
						</button>
					</div>
				</div>
			</details>

			<!-- =============================================
			     EVIDENCIAS
			     ============================================= -->
			<details class="setting-card">
				<summary class="setting-card__summary">
					<div class="setting-card__identity">
						<span class="setting-card__icon">
							<i class="pi pi-camera"></i>
						</span>

						<div>
							<strong>Evidencias</strong>
							<small>
								Resolución y frecuencia de captura
							</small>
						</div>
					</div>

					<i
						class="pi pi-chevron-down setting-card__chevron"
					></i>
				</summary>

				<div class="setting-card__body">
					<div class="setting-subsection">
						<div class="setting-subsection__heading">
							<div>
								<strong>Resolución</strong>
								<small>
									Tamaño de la imagen capturada
								</small>
							</div>

							<span class="setting-value">
								{{ resWidth }} × {{ resHeight }}
							</span>
						</div>

						<div class="form-grid">
							<div class="form-field">
								<label for="width">
									Ancho
								</label>

								<div class="input-group">
									<input
										id="width"
										type="number"
										class="form-control"
										[(ngModel)]="resWidth"
										name="resWidth"
										min="320"
										step="1"
									/>

									<span class="input-group-text">
										px
									</span>
								</div>
							</div>

							<div class="form-field">
								<label for="height">
									Alto
								</label>

								<div class="input-group">
									<input
										id="height"
										type="number"
										class="form-control"
										[(ngModel)]="resHeight"
										name="resHeight"
										min="240"
										step="1"
									/>

									<span class="input-group-text">
										px
									</span>
								</div>
							</div>
						</div>

						<div class="setting-actions">
							<button
								type="button"
								class="btn btn-primary"
								(click)="
									applyResolution(
										resWidth,
										resHeight
									)
								"
								[disabled]="
									!resWidth ||
									!resHeight ||
									resWidth < 320 ||
									resHeight < 240
								"
							>
								<i class="pi pi-check"></i>
								Aplicar
							</button>

							<button
								type="button"
								class="btn btn-outline-secondary"
								(click)="
									sendcommand(
										'GET_RES',
										'Solicitando resolución'
									)
								"
							>
								<i class="pi pi-refresh"></i>
								Consultar
							</button>
						</div>
					</div>

					<div class="setting-divider"></div>

					<div class="setting-subsection">
						<div class="setting-subsection__heading">
							<div>
								<strong>Frecuencia de captura</strong>
								<small>
									Intervalo entre evidencias
								</small>
							</div>

							<span class="setting-value">
								{{ timeMinutes ?? 0 }} min
							</span>
						</div>

						<div class="form-field">
							<label for="timeMinutes">
								Minutos
							</label>

							<div class="input-group">
								<input
									id="timeMinutes"
									type="number"
									class="form-control"
									[(ngModel)]="timeMinutes"
									name="timeMinutes"
									min="1"
									max="300"
									step="1"
								/>

								<span class="input-group-text">
									min
								</span>
							</div>
						</div>

						<div class="setting-actions">
							<button
								type="button"
								class="btn btn-primary"
								(click)="applyTime(timeMinutes)"
								[disabled]="
									timeMinutes === null ||
									timeMinutes === undefined ||
									timeMinutes < 1
								"
							>
								<i class="pi pi-check"></i>
								Aplicar
							</button>

							<button
								type="button"
								class="btn btn-outline-secondary"
								(click)="
									sendcommand(
										'GET_TIME_SHOOT',
										'Solicitando tiempo de evidencias'
									)
								"
							>
								<i class="pi pi-refresh"></i>
								Consultar
							</button>
						</div>
					</div>
				</div>
			</details>

			<!-- =============================================
			     MODO DE CAPTURA
			     ============================================= -->
			<details class="setting-card">
				<summary class="setting-card__summary">
					<div class="setting-card__identity">
						<span class="setting-card__icon">
							<i class="pi pi-images"></i>
						</span>

						<div>
							<strong>Origen de evidencia</strong>
							<small>
								Pantalla o cámara física
							</small>
						</div>
					</div>

					<span class="setting-card__summary-end">
						<span class="setting-value">
							{{ type_shoot ? "Cámara" : "Pantalla" }}
						</span>

						<i
							class="pi pi-chevron-down setting-card__chevron"
						></i>
					</span>
				</summary>

				<div class="setting-card__body">
					<div class="capture-selector">
						<button
							type="button"
							class="capture-option"
							[class.capture-option--active]="!type_shoot"
							(click)="type_shoot = false"
						>
							<i class="pi pi-desktop"></i>

							<span>
								<strong>Pantalla</strong>
								<small>
									Captura el contenido reproducido
								</small>
							</span>
						</button>

						<button
							type="button"
							class="capture-option"
							[class.capture-option--active]="type_shoot"
							(click)="type_shoot = true"
						>
							<i class="pi pi-camera"></i>

							<span>
								<strong>Cámara</strong>
								<small>
									Utiliza la cámara física
								</small>
							</span>
						</button>
					</div>

					<div
						class="capture-description"
						[class.capture-description--camera]="type_shoot"
					>
						<i
							class="pi"
							[class.pi-desktop]="!type_shoot"
							[class.pi-camera]="type_shoot"
						></i>

						<span *ngIf="!type_shoot">
							Las evidencias se obtendrán mediante capturas
							de pantalla del reproductor.
						</span>

						<span *ngIf="type_shoot">
							Las evidencias se obtendrán desde el módulo
							de cámara física.
						</span>
					</div>

					<div class="setting-actions">
						<button
							type="button"
							class="btn btn-primary"
							(click)="applyTypeShoot(type_shoot)"
						>
							<i class="pi pi-check"></i>
							Aplicar
						</button>

						<button
							type="button"
							class="btn btn-outline-secondary"
							(click)="
								sendcommand(
									'IS_TYPESHOOT',
									'Solicitando modo de captura actual'
								)
							"
						>
							<i class="pi pi-refresh"></i>
							Consultar
						</button>
					</div>
				</div>
			</details>
		</aside>
	</div>

	<!-- =====================================================
	     ACCIONES RÁPIDAS
	     ===================================================== -->
	<footer
		class="remote-console__footer"
		*ngIf="actionsOther?.length"
	>
		<div class="remote-console__footer-heading">
			<i class="pi pi-bolt"></i>

			<div>
				<strong>Acciones rápidas</strong>
				<small>
					Comandos adicionales del dispositivo
				</small>
			</div>
		</div>

		<div class="quick-actions">
			<button
				*ngFor="
					let item of actionsOther;
					trackBy: trackByLabel
				"
				type="button"
				class="btn btn-outline-primary quick-action"
				(click)="
					sendcommand(
						item.command,
						item.msgDisplay
					)
				"
			>
				{{ item.label }}
			</button>
		</div>
	</footer>
</div>